import {
    FaInfoCircle,
    FaFileContract,
    FaUserShield,
    FaCode,
    FaChevronRight,
} from "react-icons/fa";

import "./CustomerAbout.css";

function CustomerAbout() {

    const items = [

        {
            title: "Version",
            value: "1.0.0",
            icon: <FaInfoCircle />,
        },

        {
            title: "Privacy Policy",
            value: "Read Policy",
            icon: <FaUserShield />,
        },

        {
            title: "Terms & Conditions",
            value: "View Terms",
            icon: <FaFileContract />,
        },

        {
            title: "Open Source Licenses",
            value: "View Licenses",
            icon: <FaCode />,
        },

    ];

    return (

        <div className="about-page">

            <div className="about-header">

                <FaInfoCircle />

                <div>

                    <h2>About HomeFoods</h2>

                    <p>

                        Fresh Homemade Food Delivered with ❤️

                    </p>

                </div>

            </div>

            <div className="about-card">

                <div className="app-logo">

                    <img
                        src="/images/logo.png"
                        alt="HomeFoods"
                    />

                    <h2>HomeFoods</h2>

                    <p>

                        Connecting customers with
                        trusted Home Chefs,
                        Restaurants,
                        Bakeries,
                        Hotels,
                        Catering Services,
                        and Provision Stores.

                    </p>

                </div>

                {

                    items.map((item,index)=>(

                        <div
                            key={index}
                            className="about-item"
                        >

                            <div className="about-left">

                                <div className="about-icon">

                                    {item.icon}

                                </div>

                                <div>

                                    <h4>

                                        {item.title}

                                    </h4>

                                    <span>

                                        {item.value}

                                    </span>

                                </div>

                            </div>

                            <FaChevronRight/>

                        </div>

                    ))

                }

            </div>

            <div className="developer">

                © 2026 HomeFoods

                <br/>

                Built with ❤️ in India

            </div>

        </div>

    );

}

export default CustomerAbout;